// retrieve data from localstorage
// export function getLocalStorage(key) {
//   const item = localStorage.getItem(key);
//   // return JSON.parse(localStorage.getItem(key));
//   return (item !== null && item !== undefined) ? JSON.parse(item) : null;
// }
function $2a0a9d2c002157bd$export$d3720feff416e85b(key) {
    const item = localStorage.getItem(key);
    // Check for both null and the string "undefined"
    if (item === null || item === "undefined") return null;
    try {
        return JSON.parse(item);
    } catch (error) {
        console.error(`Error parsing JSON for key: ${key}`, error);
        return null; // If parsing fails, return null
    }
}
function $2a0a9d2c002157bd$export$1f73f60bdb811cb1(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}
// export function getMyData(id, key) {
// Function to convert the string date (MM/DD/YYYY) to a Date object
function $2a0a9d2c002157bd$var$convertToDateObj(stringDate) {
    const [month, day, year] = stringDate.split("/");
    return new Date(year, month - 1, day); //return a date object with string values
}
function $2a0a9d2c002157bd$export$1252491eefa66747(apiDate, selectedDate) {
    const apiDateObj = $2a0a9d2c002157bd$var$convertToDateObj(apiDate); // Convert API date to Date object
    const selectedDateObj = new Date(selectedDate); // Convert selected date (Mon Oct 14 2024) to Date object
    // Compare the two dates (year, month, day)
    return apiDateObj.getFullYear() === selectedDateObj.getFullYear() && apiDateObj.getMonth() === selectedDateObj.getMonth() && apiDateObj.getDate() === selectedDateObj.getDate();
}
function $2a0a9d2c002157bd$export$329b86aa495c7d2b(selectedDate) {
    const dateObj = new Date(selectedDate); // Convert the string into a Date object
    // Get the month, day, and year from the Date object
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    // Return the date in MM/DD/YYYY format
    return `${month}/${day}/${year}`;
}
function $2a0a9d2c002157bd$export$b405e4ac657f26ad(timeStr) {
    const [time, modifier] = timeStr.toLowerCase().split(/(a|p)/); // Split into time and AM/PM
    let [hours, minutes] = time.split(":").map(Number);
    if (modifier === "p" && hours !== 12) hours += 12; // Convert PM to 24-hour time, except for 12 PM
    if (modifier === "a" && hours === 12) hours = 0; // Convert 12 AM to 00:00 in 24-hour time
    // Format the result into "HH:mm" format
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
}
function $2a0a9d2c002157bd$export$28e08eff11ac64f6(ElementID) {
    // console.log('inside clearColumnTwo')
    const DOMElement = document.getElementById(ElementID);
    DOMElement.classList.add("column-reverse-animate");
    setTimeout(()=>{
        DOMElement.innerHTML = "";
        DOMElement.classList.remove("column-reverse-animate");
    }, 800);
}
function $2a0a9d2c002157bd$export$ec7d3deec108ed30(ElementID) {
    const DOMElement = document.getElementById(ElementID);
    DOMElement.classList.add("column-animate");
    setTimeout(()=>DOMElement.classList.remove("column-animate"), 800);
}


class $eba40cab6810b214$export$2e2bcd8739ae039 {
    constructor(){
        this.displayDOM = document.querySelector(".display");
        this.previousDOM = document.querySelector(".left");
        this.nextDOM = document.querySelector(".right");
        this.days = document.querySelector(".days");
        this.selected = document.querySelector(".selected");
        this.date = new Date();
        this.date.setDate(1); //normalize
        this.year = this.date.getFullYear();
        this.month = this.date.getMonth();
        this.selectedDate = this.date.toDateString(); //set selected date to current date initially
        this.init();
    }
    init() {
        this.displayCalendar();
        this.displaySelected();
        this.handlePrevious();
        this.handleNext();
    }
    displayCalendar() {
        const firstDay = new Date(this.year, this.month, 1);
        const firstDayIndex = firstDay.getDay();
        const lastDay = new Date(this.year, this.month + 1, 0);
        const numberOfDays = lastDay.getDate();
        // let stringDate = this.date.toLocaleString("en-US", {
        //     month: "long",
        //     year: "numeric",
        // });
        const headerDate = new Date(this.year, this.month, 1);
        let stringDate = headerDate.toLocaleString("en-US", {
            month: "long",
            year: "numeric"
        });
        // console.log("stringDate", stringDate);
        this.displayDOM.innerHTML = `${stringDate}`;
        this.days.innerHTML = ""; // Clear previous days
        // Display empty divs for the days of the previous month
        for(let x = 1; x <= firstDayIndex; x++){
            let div = document.createElement("div");
            div.innerHTML = "";
            this.days.appendChild(div);
        }
        // Display the actual days of the current month
        for(let i = 1; i <= numberOfDays; i++){
            let div = document.createElement("div");
            let currentDate = new Date(this.year, this.month, i);
            div.dataset.date = currentDate.toDateString();
            div.innerHTML = i;
            this.days.appendChild(div);
            if (currentDate.getFullYear() === new Date().getFullYear() && currentDate.getMonth() === new Date().getMonth() && currentDate.getDate() === new Date().getDate()) div.classList.add("current-date");
        }
    }
    displaySelected() {
        const dayElementsDOM = document.querySelectorAll(".days div");
        let previouslySelected = null; //to keep track of the previously selected element        
        dayElementsDOM.forEach((day)=>{
            // console.log("day: " + day);
            day.addEventListener("click", (event)=>{
                // console.log('this.selectedDate before assignment: ', this.selectedDate);
                const selectedDate = event.target.dataset.date;
                // console.log('selectedDate: ' + selectedDate);              
                this.selectedDate = selectedDate;
                //remove the outline from the previously selected date, if there is one                
                if (previouslySelected) previouslySelected.classList.remove("selected-outline");
                //add the outline to the currently selected date
                event.target.classList.add("selected-outline");
                //update the selected date display                
                // console.log("selectedDate: "+selectedDate);
                this.selected.innerHTML = `Selected Date: ${selectedDate}`;
                //udpate the previously selected element
                previouslySelected = event.target;
            });
        });
    }
    handlePrevious() {
        this.previousDOM.addEventListener("click", ()=>{
            this.days.innerHTML = "";
            this.selected.innerHTML = "";
            this.month--;
            if (this.month < 0) {
                this.month = 11;
                this.year--;
            }
            // this.date.setMonth(this.month);  //this wasn't changing the year
            this.date = new Date(this.year, this.month, 1);
            this.displayCalendar();
            this.displaySelected();
        });
    }
    handleNext() {
        this.nextDOM.addEventListener("click", ()=>{
            this.days.innerHTML = "";
            this.selected.innerHTML = "";
            this.month++;
            if (this.month > 11) {
                this.month = 0;
                this.year++;
            }
            // this.date.setMonth(this.month);
            this.date = new Date(this.year, this.month, 1);
            this.displayCalendar();
            this.displaySelected();
        });
    }
    getSelectedDate() {
        this.selectedDate = (0, $2a0a9d2c002157bd$export$329b86aa495c7d2b)(this.selectedDate);
        return this.selectedDate;
    }
}



const $0e5ca7fa55468ee1$var$binId = "6971194bd0ea881f407b41e3";
const $0e5ca7fa55468ee1$var$apiKey = "$2a$10$mlDNyCpYZTMLYq6N57nb4.uwF0MLWmq5H2Y3IAZLE7FAr.9Sl69ni";
const $0e5ca7fa55468ee1$var$baseURL = "https://api.jsonbin.io/v3/b/";
async function $0e5ca7fa55468ee1$var$convertToJson(res) {
    const jsonResponse = await res.json(); // Convert the response to JSON first
    if (res.ok) return jsonResponse; // If response is okay, return the JSON data
    else // Throw a custom error object with the response body
    throw {
        name: "servicesError",
        message: jsonResponse
    };
}
//normalize date to MM/DD/YYYY
const $0e5ca7fa55468ee1$var$padMMDDYYYY = (dateStr)=>{
    if (!dateStr || typeof dateStr !== "string") return null;
    const parts = dateStr.split("/");
    if (parts.length !== 3) return null;
    const [monthRaw, dayRaw, yearRaw] = parts;
    const mm = String(parseInt(monthRaw, 10)).padStart(2, "0");
    const dd = String(parseInt(dayRaw, 10)).padStart(2, "0");
    let yyyy = String(parseInt(yearRaw, 10));
    // add 20 to year if only two numbers (2/9/26 -> 02/09/2026)
    if (yyyy.length === 2) yyyy = `20${yyyy}`;
    if (!yyyy || yyyy.length !== 4) return null;
    return `${mm}/${dd}/${yyyy}`;
};
const $0e5ca7fa55468ee1$var$normalizeTime = (timeStr)=>{
    return String(timeStr ?? "").trim().toLocaleLowerCase().replace(/\s+/g, "");
};
class $0e5ca7fa55468ee1$export$2e2bcd8739ae039 {
    //constructor
    constructor(){
        this.baseURL = $0e5ca7fa55468ee1$var$baseURL;
        this.binId = $0e5ca7fa55468ee1$var$binId;
        this.apiKey = $0e5ca7fa55468ee1$var$apiKey;
    }
    //test function to get all data - this is working
    async getMyData() {
        try {
            const response = await fetch(this.baseURL + `${this.binId}/latest`, {
                method: "GET",
                headers: {
                    "X-Master-Key": this.apiKey
                }
            });
            if (!response.ok) throw new Error("Network response was not ok " + response.statusText);
            const data = await response.json();
            return data; // Return the fetched data here
        } catch (error) {
            console.error("There has been a problem with your fetch operation:", error);
        }
    }
    async getFilteredDataByDay(selectedDate) {
        try {
            const response = await fetch(this.baseURL + `${this.binId}/latest`, {
                method: "GET",
                headers: {
                    "X-Master-Key": this.apiKey
                }
            });
            const myData = await response.json();
            // console.log('Data for ColumnOne after response.json(): ', myData);
            const formattedDate = (0, $2a0a9d2c002157bd$export$329b86aa495c7d2b)(selectedDate);
            const targetDate = $0e5ca7fa55468ee1$var$padMMDDYYYY(formattedDate);
            //normalize filtered data
            const filteredData = myData.record.filter((item)=>{
                if (!item.When) return false;
                return $0e5ca7fa55468ee1$var$padMMDDYYYY(item.When) === targetDate;
            });
            // console.log("Target date: ", targetDate);
            // console.log("Matches found: ", filteredData.length);
            return filteredData;
        } catch (error) {
            console.error("Error fetching or filtering data:", error);
        }
    }
    async getDataByTime(selectedDate, selectedTime = "9:00a") {
        try {
            // console.log('inside getDataByTime', selectedDate, selectedTime);      
            //normalize date and time
            const normalDate = $0e5ca7fa55468ee1$var$padMMDDYYYY((0, $2a0a9d2c002157bd$export$329b86aa495c7d2b)(selectedDate));
            const normalTime = $0e5ca7fa55468ee1$var$normalizeTime(selectedTime);
            // const jsonPath = `$[?(@.When == '${dateForQuery}' && @.Time == '${timeForQuery}')]`;
            const response = await fetch(this.baseURL + `${this.binId}/latest?meta=false`, {
                method: "GET",
                headers: {
                    "X-Master-Key": this.apiKey
                }
            });
            const myData = await response.json();
            // console.log('myData in getDataByTime after response.json()', myData);      
            // handle both array or record object of arrays
            const records = Array.isArray(myData) ? myData : myData?.record;
            if (!Array.isArray(records)) {
                console.warn("Unexpected data type/shape: ", myData);
                return [];
            }
            const matches = records.filter((item)=>{
                if (!item.When || !item.Time) return false;
                const itemDate = $0e5ca7fa55468ee1$var$padMMDDYYYY(item.When);
                const itemTime = $0e5ca7fa55468ee1$var$normalizeTime(item.Time);
                return itemDate === normalDate && itemTime === normalTime;
            });
            // console.log("Normalized Date/Time: ", normalDate, normalTime);
            // console.log("Time Matches found: ", matches.length);
            return matches;
        } catch (error) {
            console.error("Error fetching or filtering data by date and time:", error);
            return [];
        }
    }
} //end class
 //set local storage here with value?
 //can I work these options into one method or do I need multiple methods?
 //get Filtered Data By Day
 //get Filtered Data by Day & Time
 //get Filtered Data by Day & Client





class $4e78ac916756de67$export$2e2bcd8739ae039 {
    constructor(data, date){
        this.selectedDate = date;
        this.dataSource = data;
        this.timeDataSource = [];
    }
    getUniqueTimes() {
        // console.log('getUniqueTimes, date: ', this.selectedDate);
        return this.dataSource.reduce((timesArray, item)=>{
            const t = item.Time ?? item.time;
            if (t && !timesArray.includes(t)) timesArray.push(t); // Add only if the time is not already in the timesArray
            this.timeDataSource = timesArray;
            // console.log("timesArray: ", timesArray);
            return timesArray;
        }, [])//assures times are in a chronological order AM to PM, converts to 24 hrs, then back
        .sort((a, b)=>(0, $2a0a9d2c002157bd$export$b405e4ac657f26ad)(a).localeCompare((0, $2a0a9d2c002157bd$export$b405e4ac657f26ad)(b)));
    }
    //not working yet as intended
    initialColumnOneTemplate() {
        const calendarColumnDOM1 = document.getElementById("calendar-column");
        const dayColumnDOM = document.createElement("div");
        dayColumnDOM.classList.add("container");
        dayColumnDOM.classList.add("column");
        // dayColumnDOM.classList.add("test");
        dayColumnDOM.id = "column-day";
        calendarColumnDOM1.insertAdjacentElement("afterend", dayColumnDOM);
    }
    //not working yet as intended
    initialColumnTwoTemplate() {
        const dayColumnDOM = document.getElementById("column-day");
        const oneTimeColumnDOM = document.createElement("div");
        dayColumnDOM.classList.add("container");
        dayColumnDOM.classList.add("column");
        dayColumnDOM.id = "time-of-day";
        calendarColumnDOM.insertAdjacentElement("afterend", dayColumnDOM);
    }
    singleClientListTemplate(data) {
        return `
        <ul class="matter-list">
            ${data.map((item, index)=>`
                <li class="button matter-item" data-matter="${item["Case Number"]}" id="matter-${index}">
                    ${item["Linked Matter"]}
                </li>
            `).join("")}
        </ul>`;
    }
    dateButtonTemplate() {
        return `<div class="title-button selectedDay">${this.selectedDate}</div>`;
    }
    timeListTemplate() {
        const timesList = this.getUniqueTimes();
        return `
        <ul class="time-group">
        ${timesList.map((time)=>`<li class="button time" data-time="${time}">${time}</li>`).join("")}
        </ul>`;
    }
    oneTimeTemplate(time) {
        return `<div class="title-button time">${time}</div>`;
    }
    clientListByTimeTemplate(data) {
        // console.log('clientListByTimeTemplate - data: ', data);
        const uniqueClients = Array.from(new Set(data.map((client)=>client["Linked Name"])));
        // console.log('uniqueClients: ', uniqueClients);
        return `
        <ul class="client-list">                
            ${uniqueClients.map((client, index)=>`<li class="button client-name" data-client="${client}" id="client-${index}" >${client}</li>`).join("")}
        </ul>`;
    }
    // this function lists multiple clients with different matters
    multClientListByTimeTemplate(data) {
        // console.log('data in muliClientListByTime: ', data);
        return `
        <ul class="client-list">                
             ${data.map((client, index)=>`<li class="button client-name" data-matter="${client["Case Number"]}" id="matter-${index}">${client["Linked Matter"]}</li>`).join("")}

        </ul>`;
    }
    renderColumnOne() {
        //this code currrently creates multiple columns if muliple dates are clicked.
        //TODO: fix
        // this.initialColumnOneTemplate();
        // const calendarColumnDOM = document.getElementById("calendar-column");
        // const dayColumnDOM = document.createElement("div");
        // dayColumnDOM.classList.add("container");
        // dayColumnDOM.classList.add("column");
        // dayColumnDOM.classList.add("test");
        // dayColumnDOM.id = "column-day";
        // console.log('dayColumnDOM', dayColumnDOM);
        // calendarColumnDOM.insertAdjacentElement("afterend", dayColumnDOM);
        const dateButtonHTML = this.dateButtonTemplate();
        const timeListHTML = this.timeListTemplate();
        const columnOneDOM = document.getElementById("column-day");
        columnOneDOM.innerHTML = dateButtonHTML + timeListHTML;
        this.attachTimeListeners();
        // Add the animation class
        columnOneDOM.classList.add("column-animate");
        // Remove the animation class after animation completes
        setTimeout(()=>columnOneDOM.classList.remove("column-animate"), 800);
    // console.log('inside renderColumnOne: ', this.selectedDate, this.dataSource, this.timeDataSource);
    }
    attachTimeListeners() {
        // console.log('begin attachTimeListeners');
        const timeButtonsDOM = document.querySelectorAll(".button.time");
        timeButtonsDOM.forEach((button)=>{
            button.addEventListener("click", ()=>{
                const time = button.dataset.time;
                // console.log('attachTimeListeners time: ', time);
                this.handleTimeClick(time);
            // this.renderColumnTwo(time);
            });
        });
    }
    handleTimeClick(time) {
        const dataByTime = new (0, $0e5ca7fa55468ee1$export$2e2bcd8739ae039)();
        //request filtered date from the api
        dataByTime.getDataByTime(this.selectedDate, time).then((newArray)=>{
            // console.log('dataByTime in handleTimeClick: ', newArray);     //returns the array of json data  
            // return dataByTime; 
            this.renderColumnTwo(newArray, time);
        }).catch((error)=>{
            console.error("Error fetching data by time:", error);
        });
    }
    renderColumnTwo(data, time) {
        // this.initialColumnTwoTemplate();  //fix for later.
        const dateButtonHTML = this.dateButtonTemplate();
        const timeButtonHTML = this.oneTimeTemplate(time);
        // const clientListHTML = this.clientListByTimeTemplate(data);
        // console.log('inside renderColumnTwo: data:', data);
        // Choose template based on local storage preference
        const viewPreference = (0, $2a0a9d2c002157bd$export$d3720feff416e85b)("client-toggle") || "by-client";
        const clientListHTML = viewPreference === "by-client" ? this.clientListByTimeTemplate(data) : this.multClientListByTimeTemplate(data);
        const columnTwoDOM = document.getElementById("time-of-day");
        columnTwoDOM.innerHTML = dateButtonHTML + timeButtonHTML + clientListHTML + this.renderColumnFooter();
        (0, $2a0a9d2c002157bd$export$ec7d3deec108ed30)("time-of-day");
        this.attachToggleListener(data, time);
        //Attach event listeners to client or matter buttons    
        const clientButtons = columnTwoDOM.querySelectorAll(".button.client-name");
        clientButtons.forEach((button)=>{
            button.addEventListener("click", (event)=>{
                const client = event.target.dataset.client || event.target.dataset.matter;
                // console.log("clientButtons in ColumnTwoDOM: ", client);
                this.handleClientMatterClick(client, data);
            });
        });
    }
    renderColumnThree(client, filteredData) {
        //check for existing column, remove if present so there's only one column three
        let columnThreeDOM = document.getElementById("client-details");
        if (columnThreeDOM) columnThreeDOM.remove();
        columnThreeDOM = document.createElement("div");
        columnThreeDOM.id = "client-details";
        columnThreeDOM.className = "container column";
        //client is either client name or case number
        //TODO: add abililty to show client name also in header if client=case number
        const clientHeader = `<div class="title-button selectedClient"> ${client}</div>`;
        const matterlistHTML = this.singleClientListTemplate(filteredData);
        //create column Three
        columnThreeDOM.innerHTML = clientHeader + matterlistHTML;
        //insert into DOM
        const columnTwoDOM = document.getElementById("time-of-day");
        if (columnTwoDOM) columnTwoDOM.insertAdjacentElement("afterend", columnThreeDOM);
        //add event listeners to each matter butto to expand for further details
        const matterButtons = columnThreeDOM.querySelectorAll(".matter-item");
        matterButtons.forEach((button)=>{
            button.addEventListener("click", (event)=>{
                //set variable to the value of the target at data-matter
                const matterId = event.target.dataset.matter;
                //where data.matter matches: the clicked button equals the filteredData item
                const singleMatter = filteredData.find((item)=>item["Case Number"] === matterId);
                if (singleMatter) //if the clicked event matches, then display HTML template with filtered data
                this.renderMatterDetailsTemplate(singleMatter, event.target);
                else console.warn(`No data found for Case Number: ${matterId}`);
            // const matterDetailsHTML = this.renderMatterDetailsTemplate(matter);
            // this.event.target.innerHTML = matterDetailsHTML;
            });
        });
    }
    renderColumnFooter() {
        try {
            const viewPreference = (0, $2a0a9d2c002157bd$export$d3720feff416e85b)("client-toggle") || "by-client";
            return `
            <footer class="column-footer">
                <button id="toggle-client-view" class="toggle-button">
                    ${viewPreference === "by-client" ? "View by Matter" : "View by Client"}
                </button>
            </footer>`;
        } catch (error) {
            console.error("Error rendering footer in Column Two", error);
        }
    }
    renderMatterDetailsTemplate(matter, targetElement) {
        //placeholder to place a form based on JSON data
        //TODO: finish form
        // console.log('matter: ', matter);
        const formHTML = `<div class="matter-details"
            <label>Client: </label><input type="text" name="clientName" value="${matter["Linked Name"]}" disabled><br>
            <label>Case Number: </label><input type="text" name="caseNumber" value="${matter["Case Number"]}" disabled><br>
            <label>What: </label> <input type="text" name="what" value="${matter.What}"><br>
            <label>Who: </label> <input type="text" name="who" value="${matter.Who}"><br>
            <label>Status: </label> <input type="text" name="status" value="${matter.Status}"><br>
            
            <label>Note: </label> <textarea rows="4" cols="50" name="status">${matter.Note}</textarea><br>
            <label>Duration: </label> <input type="text" name="duration" value="${matter.Duration}"><br>
        </div>`;
        targetElement.innerHTML = formHTML;
    }
    attachToggleListener(data, time) {
        // console.log('inside attachToggleListener, data: ', data);
        const toggleButton = document.getElementById("toggle-client-view");
        toggleButton.addEventListener("click", ()=>{
            // Toggle between 'by-client' and 'by-matter'
            const currentPreference = (0, $2a0a9d2c002157bd$export$d3720feff416e85b)("client-toggle") || "by-client";
            const newPreference = currentPreference === "by-client" ? "by-matter" : "by-client";
            // Update local storage
            (0, $2a0a9d2c002157bd$export$1f73f60bdb811cb1)("client-toggle", newPreference);
            // Update button label and re-render the client list
            toggleButton.innerText = newPreference === "by-client" ? "View by Matter" : "View by Client";
            const columnTwoDOM = document.getElementById("time-of-day");
            columnTwoDOM.innerHTML = ""; // Clear current content
            this.renderColumnTwo(data, time); // Re-render with updated view
        });
    }
    handleClientMatterClick(client, data) {
        //Filter data to get all items to match selected
        const filteredData = data.filter((item)=>item["Linked Name"] === client || item["Case Number"] === client);
        // console.log('handleClientMatterClick client:', client);
        this.renderColumnThree(client, filteredData);
    }
} //end column class


function $e69eb4489b3aa2e5$export$715fbaf6626971d2() {
    const headerHTML = `
    <header>
        <h1 class="title">Abacus Law Calendar App</h1>
        <button class="toggle-button" id="dark-toggle" aria-label="dark light toggle button">Dark/Light Mode</button>
    </header>`;
    const footerHTML = `
    <footer>
        <p>&copy; 2024, 2026 | Kerri Morris | Abacus Law Calendar App</p>
    </footer>`;
    // Insert the header at the beginning of the body
    document.body.insertAdjacentHTML("afterbegin", headerHTML);
    // Insert the footer at the end of the body
    document.body.insertAdjacentHTML("beforeend", footerHTML);
}



function $1af4c0aef7844f75$export$808aaf1b460dc9af() {
    const darkModeToggle = document.querySelector("#dark-toggle");
    //check for saved preferences, or use light 
    const currentTheme = (0, $2a0a9d2c002157bd$export$d3720feff416e85b)("theme") || "light";
    if (currentTheme === "dark") document.body.classList.add("dark-mode");
    darkModeToggle.addEventListener("click", ()=>{
        document.body.classList.toggle("dark-mode");
        //save preferences in local storage
        const theme = document.body.classList.contains("dark-mode") ? "dark" : "light";
        (0, $2a0a9d2c002157bd$export$1f73f60bdb811cb1)("theme", theme);
    });
}


// const binId = process.env.PARCEL_BIN_ID;
// const apiKey = process.env.PARCEL_API_MASTER_KEY;
// const baseURL=process.env.PARCEL_URL;
//load calendar on screen load
document.addEventListener("DOMContentLoaded", ()=>{
    const calendar = new (0, $eba40cab6810b214$export$2e2bcd8739ae039)();
    (0, $e69eb4489b3aa2e5$export$715fbaf6626971d2)();
    (0, $1af4c0aef7844f75$export$808aaf1b460dc9af)();
    //get local storage if there is anything there.
    const storedDataByDay = (0, $2a0a9d2c002157bd$export$d3720feff416e85b)("filtered-by-day") || null;
    // console.log('storedDataByDate: ', storedDataByDay);
    // if (storedDataByDay === undefined || storedDataByDay === null) storedDataByDay = [];
    //if there's a date in local storage, then load the first column with that date
    if (storedDataByDay && storedDataByDay.length > 0) {
        const selectedDate = storedDataByDay[0]?.When || calendar.getSelectedDate();
        // console.log('Loaded data from Local Storage:', storedDataByDay);
        const column = new (0, $4e78ac916756de67$export$2e2bcd8739ae039)(storedDataByDay, selectedDate);
        column.renderColumnOne();
    }
    document.querySelector(".days").addEventListener("click", ()=>{
        const selectedDate = calendar.getSelectedDate(); // Get the selected date
        //clear client list column: TODO, refactor to add eventListener for column two in this file?
        (0, $2a0a9d2c002157bd$export$28e08eff11ac64f6)("time-of-day");
        if (selectedDate) {
            // console.log('Selected date in intial click event:', selectedDate);  // Log it when a date is clicked
            //get new updated data with click.  Is here where I want this?           
            const myfilteredData = new (0, $0e5ca7fa55468ee1$export$2e2bcd8739ae039)();
            myfilteredData.getFilteredDataByDay(selectedDate).then((filteredData)=>{
                // console.log('Filtered Data in index: ', filteredData);
                (0, $2a0a9d2c002157bd$export$1f73f60bdb811cb1)("filtered-by-day", filteredData);
                const columnOne = new (0, $4e78ac916756de67$export$2e2bcd8739ae039)(filteredData, selectedDate);
                // console.log('selectedDate after creating columnOne: ', selectedDate);
                columnOne.renderColumnOne();
            });
        }
    });
}); //end of eventListener on initial load


//# sourceMappingURL=index.e4391ab9.js.map
